@if (languagesSwitcherEnabled) {
  <div class="NavMobileMenu__ListItem">
    <div class="u-flex">
      <div class="u-flex u-alignCenter u-maxX">
        <icon
          class="NavLink__icon"
          [name]="config?.mobileOptions?.icon"
          [config]="{ fill: 'nav-icon-color' }"
          prefix
        ></icon>
        <p class="NavLink__title">{{ config?.mobileOptions?.title }}</p>
      </div>
      <div
        class="u-flex u-alignCenter icon--link"
        (click)="openLanguageModal = true"
      >
        <p class="NavLink__title">{{ activeLangKeyLabel }}</p>
        <icon
          class="NavLink__icon"
          name="chevron_right"
          [config]="{ fill: 'nav-icon-color' }"
          prefix
        ></icon>
      </div>
    </div>
    @if (!!config) {
      <modal
        (cancel)="openLanguageModal = false"
        [condition]="openLanguageModal"
        [config]="{
          header: {
            title: config?.mobileOptions?.title,
            closeIcon: 'close',
            showClose: true,
          },
          type: 'flyout',
        }"
        data-test-id="languageChangeModal"
      >
        <ng-container body>
          <form-group
            data-test-id="languageForm"
            [form]="languageForm"
            [configs]="languageControl"
            direction="filter"
          >
          </form-group>
        </ng-container>
        <ng-container footer>
          <div
            class="u-flex u-justifyBetween u-maxX"
            data-test-id="accumulatorMainFooter"
          >
            <zip-button
              (zipButtonClicked)="openLanguageModal = false"
              [config]="config?.mobileOptions?.cancelButton"
              data-test-id="languageCancelButton"
            >
            </zip-button>
            <zip-button
              (zipButtonClicked)="handleLanguageChange()"
              [config]="config?.mobileOptions?.saveButton"
              data-test-id="languageSaveButton"
            >
            </zip-button>
          </div>
        </ng-container>
      </modal>
    }
  </div>
}
